module.exports ={
    login: {
        company:'云里物里',
        platform:'云里物里智慧零售平台',
        account:'账号',
        password:'密码',
        login:'登 录',
        logining:'登 录 中...',
        loginTip: {
            exist: '用户不存在',
            passwordErr: '密码错误',
            // permission:'您没有权限使用该平台',
            permission:'请联系管理员为您分配门店',
            msgErr:'用户名或密码错误',
            fail:'登录失败',
            storeClose: '门店已关闭,请联系管理员',
            storeExist: '您所属的门店不存在',
            valid: '用户无效,请联系管理员',
            chooseSys: '请联系管理员先选择所需的应用场景'
        },
        validMsg: {
            userName:'请输入用户名',
            userNameRule: '请输入字母或数字',
            length1:'请输入6-20位密码',
            // nameLen:'长度在不能超过20个字符'
            password:'请输入用户密码',
            passRule:'用户密码不能包含空格',
            passRule1:'用户密码不能包含中文'
        },
        logoSrc: "/static/images/logo.png",
        chooseSysType: '请选择应用场景',
        // sysTypeOpts: ['零售', '医疗'],
        sysTypeOpts: [
            {
                label: '零售',
                value: 'retail'
            },{
                label: '医疗',
                value: 'medical'
            },{
                label: '自定义场景',
                value: 'custom'
            }
        ],
        sysTips: '提示：本选项只在初次使用时才提供，请选择所需的应用场景',
        sure: '确 定',
        cancel: '取 消',
        chooseSysTip: {
            operateFail: '选择场景失败',
            exist: '选择的场景不存在',
            choosed: '您已经选择了使用的场景，请直接登录'
        },
        customLabel: '场景字段编辑',
        labelEditLabel: {
            id: { zh: { label: 'id', value: 'ID' }, en: { label: 'id', value: 'ID' }, ja: { label: 'id', value: 'ID' } },
            barcode: { zh: { label: '条形码', value: '条形码' }, en: { label: '条形码', value: 'Barcode' }, ja: { label: '条形码', value: 'バーコード' } },
            qrcode: { zh: { label: '二维码', value: '二维码' }, en: { label: '二维码', value: 'Qrcode' }, ja: { label: '二维码', value: 'QRコード' } },
            label1: { zh: { label: '字段1', value: '条形码文本' }, en: { label: '字段1', value: 'Barcode Text' }, ja: { label: '字段1', value: 'バーコードテキスト' } },
            label2: { zh: { label: '字段2', value: '二维码文本' }, en: { label: '字段2', value: 'Qrcode Text' }, ja: { label: '字段2', value: 'QRコードテキスト' } },
            label3: { zh: { label: '字段3', value: '预留1' }, en: { label: '字段3', value: 'Placeholder1' }, ja: { label: '字段3', value: '予約1' } },
            label4: { zh: { label: '字段4', value: '预留2' }, en: { label: '字段4', value: 'Placeholder2' }, ja: { label: '字段4', value: '予約2' } },
            label5: { zh: { label: '字段5', value: '预留3' }, en: { label: '字段5', value: 'Placeholder3' }, ja: { label: '字段5', value: '予約3' } },
            label6: { zh: { label: '字段6', value: '预留4' }, en: { label: '字段6', value: 'Placeholder4' }, ja: { label: '字段6', value: '予約4' } },
            label7: { zh: { label: '字段7', value: '预留5' }, en: { label: '字段7', value: 'Placeholder5' }, ja: { label: '字段7', value: '予約5' } },
            label8: { zh: { label: '字段8', value: '预留6' }, en: { label: '字段8', value: 'Placeholder6' }, ja: { label: '字段8', value: '予約6' } },
            label9: { zh: { label: '字段9', value: '预留7' }, en: { label: '字段9', value: 'Placeholder7' }, ja: { label: '字段9', value: '予約7' } },
            label10: { zh: { label: '字段10', value: '预留8' }, en: { label: '字段10', value: 'Placeholder8' }, ja: { label: '字段10', value: '予約8' } },
            label11: { zh: { label: '字段11', value: '预留9' }, en: { label: '字段11', value: 'Placeholder9' }, ja: { label: '字段11', value: '予約9' } },
            label12: { zh: { label: '字段12', value: '预留10' }, en: { label: '字段12', value: 'Placeholder10' }, ja: { label: '字段12', value: '予約10' } },
            label13: { zh: { label: '字段13', value: '预留11' }, en: { label: '字段13', value: 'Placeholder11' }, ja: { label: '字段13', value: '予約11' } },
            label14: { zh: { label: '字段14', value: '预留12' }, en: { label: '字段14', value: 'Placeholder12' }, ja: { label: '字段14', value: '予約12' } },
            label15: { zh: { label: '字段15', value: '预留13' }, en: { label: '字段15', value: 'Placeholder13' }, ja: { label: '字段15', value: '予約13' } },
            label16: { zh: { label: '字段16', value: '预留14' }, en: { label: '字段16', value: 'Placeholder14' }, ja: { label: '字段16', value: '予約14' } },
            label17: { zh: { label: '字段17', value: '预留15' }, en: { label: '字段17', value: 'Placeholder15' }, ja: { label: '字段17', value: '予約15' } },
            label18: { zh: { label: '字段18', value: '预留16' }, en: { label: '字段18', value: 'Placeholder16' }, ja: { label: '字段18', value: '予約16' } },
            photo1: { zh: { label: '图片1', value: '图片1' }, en: { label: '图片1', value: 'photo1' }, ja: { label: '图片1', value: '画像1' } },
            photo2: { zh: { label: '图片2', value: '图片2' }, en: { label: '图片2', value: 'photo2' }, ja: { label: '图片2', value: '画像2' } },
            photo3: { zh: { label: '图片3', value: '图片3' }, en: { label: '图片3', value: 'photo3' }, ja: { label: '图片3', value: '画像3' } },
            photo4: { zh: { label: '图片4', value: '图片4' }, en: { label: '图片4', value: 'photo4' }, ja: { label: '图片4', value: '画像4' } },
            photo5: { zh: { label: '图片5', value: '图片5' }, en: { label: '图片5', value: 'photo5' }, ja: { label: '图片5', value: '画像5' } }
        },
        labelEditValidMsg: {
            label1: '请输入字段1',
            label2: '请输入字段2',
            label3: '请输入字段3',
            label4: '请输入字段4',
            label5: '请输入字段5',
            label6: '请输入字段6',
            label7: '请输入字段7',
            label8: '请输入字段8',
            label9: '请输入字段9',
            label10: '请输入字段10',
            label11: '请输入字段11',
            label12: '请输入字段12',
            label13: '请输入字段13',
            label14: '请输入字段14',
            label15: '请输入字段15',
            label16: '请输入字段16',
            label17: '请输入字段17',
            label18: '请输入字段18',
            label19: '请输入字段19',
            label20: '请输入字段20',
            input: '请输入{name}',
            sence: '请输入场景名',
            senceExist: '场景名已存在',
            senceFail: '获取失败,请重新输入',
            senceLang: '请选择场景字段语言'
        },
        labelEditTips: {
            getLabelNameFail: '获取字段名称失败',
            success: '字段名称编辑成功',
            fail: '字段名称编辑失败'
        },
        sence: {
            edit: '场景编辑',
            name: '场景名',
            labelLang: '场景字段语言'
        },
        senceLang: [
            {
                langVal: 'zh',
                langLabel: '中文',
                editTitle: '中文字段编辑'
            },{
                langVal: 'en',
                langLabel: '英文',
                editTitle: '英文字段编辑'
            },{
                langVal: 'ja',
                langLabel: '日文',
                editTitle: '日文字段编辑'
            }
        ],
        submiting: '提交中...',
    }
}


// WEBPACK FOOTER //
// ./src/components/common/lang/zh/login.js